import { defineComponent, computed, provide, inject, ref } from 'vue';
import props from './props';

import { usePrefixClass } from '../hooks/useConfig';
import { useTNodeJSX } from '../hooks/tnode';
import Text from './chat-content';
import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import { Skeleton as TSkeleton, Button as TButton, Space as TSpace, Icon as TIcon } from 'tdesign-vue-next';
import ChatLoading from './chat-loading';

export default defineComponent({
  name: 'TChatItem',
  components: {
    TSkeleton,
    TButton,
    TIcon,
    TSpace,
    Text,
  },
  props,
  emits: ['operation'],
  setup(props, { emit }) {
    const COMPONENT_NAME = usePrefixClass('chat');
    const renderTNodeJSX = useTNodeJSX();
    const role = computed(() => renderTNodeJSX('role'));
    const variant = computed(() => renderTNodeJSX('variant'));
    // content为default时给子组件注入,模型切换时不注入数据，否则variant样式混乱
    provide('role', role.value);
    // 预留占位：t-chat注入textLoading和reverse
    // const textLoading = inject('textLoading', props.textLoading);
    // const reverse = inject('reverse', props.reverse);
    return () => {
      if (role.value === 'model-change') {
        // modelChange 模式下，content支持html，样式有区分
        const content = renderTNodeJSX('content');
        const modelChangeDom = <div class={`${COMPONENT_NAME.value}__notice`} v-html={content}></div>;
        return <div class={`${COMPONENT_NAME.value}__inner model-change`}>{modelChangeDom}</div>;
      }
      // 因为外层的role不能拿到实时更新的值，但是又要给子组件注入，所以这里单独另存了个变量
      const roleValue = renderTNodeJSX('role');
      const movable = renderTNodeJSX('movable');
      const name = renderTNodeJSX('name');
      const datetime = renderTNodeJSX('datetime');
      const avatar = renderTNodeJSX('avatar');
      const shownameDatetime = computed(() => name || datetime);
      // shownameDatetime存在时，contentClasses有个padding-top
      const contentClasses = computed(() => {
        return shownameDatetime.value
          ? [`${COMPONENT_NAME.value}__content`]
          : [`${COMPONENT_NAME.value}__content`, `${COMPONENT_NAME.value}__content--base`];
      });
      const avatarDom = avatar ? (
        <div class={`${COMPONENT_NAME.value}__avatar`}>
          <div class={`${COMPONENT_NAME.value}__avatar__box`}>
            {isString(avatar) ? <img src={avatar} alt="" class={`${COMPONENT_NAME.value}__avatar-image`} /> : avatar}
          </div>
        </div>
      ) : null;
      const nameDatetimeDom = shownameDatetime.value && (
        <div class={`${COMPONENT_NAME.value}__base`}>
          {name && <span class={`${COMPONENT_NAME.value}__name`}>{name}</span>}
          {datetime && <span class={`${COMPONENT_NAME.value}__time`}>{datetime}</span>}
        </div>
      );
      // todo 结合reverse属性，倒序是第一个元素loading，倒序是最后一个元素loading
      // const showLoad = props.itemIndex === 0 && textLoading && reverse;
      const textLoading = props.textLoading;
      const content = renderTNodeJSX('content');
      // 内置操作按钮，assistantActions和插槽判断 t-chat注入的属性获取不到默认为false
      const showActions = computed(() => renderTNodeJSX('actions'));
      const contentDom = (
        <>
          {avatarDom}
          <div class={contentClasses.value}>
            {nameDatetimeDom}
            {/* 骨架屏加载 */}
            {textLoading && <t-skeleton loading={textLoading} animation={'gradient'}></t-skeleton>}
            {/* 动画加载 skeleton：骨架屏 gradient：渐变加载动画一个点 dot：三个点 */}
            {textLoading && movable && <ChatLoading loading={textLoading} animation={'gradient'}></ChatLoading>}
            {!textLoading && (
              <div class={`${COMPONENT_NAME.value}__detail`}>
                {/* 自定义content插槽内容 */}
                {isArray(content) ? content : <Text isNormalText={false} content={content} role={role.value} />}
              </div>
            )}
            {role.value === 'assistant' && showActions.value && (
              <div class={`${COMPONENT_NAME.value}__actions-margin`}>{renderTNodeJSX('actions')}</div>
            )}
          </div>
        </>
      );
      return (
        <div
          class={`${COMPONENT_NAME.value}__inner ${roleValue} ${COMPONENT_NAME.value}__text--variant--${variant.value}`}
        >
          {contentDom}
        </div>
      );
    };
  },
});
